// Perform a navigation to a URL
export const navigateTo = function (url: string) {
  // for testing navigation in Cypress
  if (window.Cypress && window.Cypress.navigateTo) {
    return window.Cypress.navigateTo(url);
  }
  window.location.assign(url);
};

export const origin = function () {
  return window.location.origin
    ? window.location.origin
    : `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }`;
};

export const searchWithHashFallback = () => {
  const hash = window.location.hash;
  // in development the querystring comes in the hash due to the anchor #
  const hashSearch = hash.indexOf("?") !== -1 ? hash.substring(hash.indexOf("?")) : "";
  const search = window.location.search || hashSearch;
  return new URLSearchParams(search);
};
